import {EventEmitter, GeneralEventData} from "./EventEmitter";

export type InAppEventHandler<T extends InAppEventType> = (data: EventMap[T]) => void;

export type InAppEventType = 'ItemDeleteStart' | 'ItemDeleteEnd' | 'AuthBack'
    | 'ContextMenuClose'  | 'HardRefreshWarning' | 'TreeScroll';

export type InAppDeleteEventData = {
    type: 'ItemDeleteStart' | 'ItemDeleteEnd',
    itemId: string,
}

export type InAppAuthBackEventData = {
    type: 'AuthBack',
}

export type InAppContextMenuCloseEventData = GeneralEventData<'ContextMenuClose'>;

export type InAppHardRefreshSuggestionEventData = GeneralEventData<'HardRefreshWarning'>;

export type InAppTreeScrollEventData = GeneralEventData<'TreeScroll', {
    scrollDirection: 'up' | 'down';
}>;

export type InAppEventData = InAppDeleteEventData | InAppAuthBackEventData | InAppContextMenuCloseEventData | InAppHardRefreshSuggestionEventData
    | InAppTreeScrollEventData;

type EventMap = {
    'ItemDeleteStart': InAppDeleteEventData;
    'ItemDeleteEnd': InAppDeleteEventData;
    'AuthBack': InAppAuthBackEventData;
    'ContextMenuClose': InAppContextMenuCloseEventData;
    'HardRefreshWarning': InAppHardRefreshSuggestionEventData;
    'TreeScroll': InAppTreeScrollEventData;
};

export class InAppEventsHub extends EventEmitter<InAppEventType, EventMap> {
}

export const inAppEventsHub =  new InAppEventsHub();
